var _path, _path2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 163,
    viewBox: "0 0 142 163",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.265 0C136.662 0.000253352 141.037 4.37542 141.037 9.77246V138.265C141.037 141.791 139.169 144.879 136.369 146.598C136.432 147.585 136.195 148.615 135.582 149.557L128.36 160.655C126.433 163.617 122.096 163.617 120.169 160.655L112.946 149.557C112.628 149.068 112.413 148.555 112.286 148.037H109.285C109.158 148.555 108.943 149.068 108.625 149.557L101.402 160.655C99.4751 163.617 95.1391 163.617 93.2119 160.655L85.9893 149.557C85.6714 149.068 85.4559 148.555 85.3291 148.037H82.4482C82.3243 148.543 82.1166 149.045 81.8105 149.523L74.7871 160.51C72.8655 163.516 68.4743 163.516 66.5527 160.51L59.5293 149.523C59.2232 149.045 59.0155 148.543 58.8916 148.037H56.0127C55.8859 148.555 55.6704 149.068 55.3525 149.557L48.1309 160.655C46.2037 163.617 41.8667 163.617 39.9395 160.655L32.7178 149.557C32.3999 149.068 32.1844 148.555 32.0576 148.037H29.0557C28.9289 148.555 28.7134 149.068 28.3955 149.557L21.1729 160.655C19.2456 163.617 14.9096 163.617 12.9824 160.655L5.75977 149.557C5.06156 148.484 4.84985 147.296 5.0166 146.187C2.56185 144.411 0.962891 141.526 0.962891 138.265V9.77246C0.962963 4.37535 5.33825 0.000129046 10.7354 0H131.265Z",
    fill: "#00A859",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5684 83.7369L63.8528 90.2092C64.8985 91.2862 66.6274 91.2862 67.6731 90.2092L86.1113 71.2197",
    stroke: "#00A859",
    strokeWidth: 4.07191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.6279,
    cy: 81.4175,
    rx: 37.9873,
    ry: 37.6709,
    fill: "#00A859",
    fillOpacity: 0.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.8343,
    cy: 81.626,
    rx: 27.7034,
    ry: 27.4727,
    fill: "#00A859",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccessIcon);
export default __webpack_public_path__ + "static/media/transaction-success-icon.3605061d25700de46c54fd8cb1a5bce7.svg";
export { ForwardRef as ReactComponent };